"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MilkRunV2Mixin = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.find-index");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _milkRunV = require("@/api/milk-run-v2.api");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MilkRunV2Mixin = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MilkRunV2Mixin, _Mixins);

  var _super = _createSuper(MilkRunV2Mixin);

  function MilkRunV2Mixin() {
    var _this;

    (0, _classCallCheck2.default)(this, MilkRunV2Mixin);
    _this = _super.apply(this, arguments);
    _this.openMapModal = false;
    _this.selectedTruckName = '';
    _this.selectedTruckData = [];
    _this.disableTruckKey = process.env.VUE_APP_DISABLE_TRUCK_KEY;
    _this.disableTruckList = [];
    _this.currentDate = (0, _moment.default)(new Date()).format('YYYY-MM-DD');
    return _this;
  }

  (0, _createClass2.default)(MilkRunV2Mixin, [{
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "$isMobile",
    get: function get() {
      return this.$store.getters['common/isMobile'];
    },
    set: function set(newVal) {
      this.$setIsMobile(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_TRUCKS",
    get: function get() {
      return this.$store.getters['milkRunV2/GLOBAL_SELECTED_TRUCKS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedTrucks(newVal);
    }
  }, {
    key: "$planDateRange",
    get: function get() {
      return this.$store.getters['milkRunV2/planDateRange'];
    },
    set: function set(newVal) {
      this.$setPlanDateRange(newVal);
    }
  }, {
    key: "$truckLoading",
    get: function get() {
      return this.$store.getters['milkRunV2/truckLoading'];
    },
    set: function set(newVal) {
      this.$setTruckLoading(newVal);
    }
  }, {
    key: "$selectedTruck",
    get: function get() {
      return this.$store.getters['milkRunV2/selectedTruck'];
    },
    set: function set(newVal) {
      this.$setSelectedTruck(newVal);
    }
  }, {
    key: "routes",
    get: function get() {
      return this.getRoutes(this.$selectedTruck);
    },
    set: function set(newVal) {
      var _this2 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['vehicleId'] === _this2.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['routes'] = newVal;
        }

        this.$setPlan({
          'plan': plan
        });
      }
    }
  }, {
    key: "created",
    value: function created() {
      if (!this.milkRunV2API) {
        this.milkRunV2API = new _milkRunV.MilkRunV2API({
          customerKey: this.$userInformation.customerKey || ''
        });
      }
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['vehicleId'] === truckId;
      }), '0.routes', []);
    }
  }, {
    key: "getStatusColor",
    value: function getStatusColor(route) {
      return {
        'pick-up': route['waypointType'] === 'P',
        'drop-off': route['waypointType'] === 'D',
        'action': route['waypointType'] === 'T'
      };
    }
  }, {
    key: "getRouteDetails",
    value: function getRouteDetails(truckId) {
      var truck = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truckId;
      }), '0', null);

      if (!truck) {
        return {
          estimatedDistance: 0,
          estimatedTravellingTime: 0
        };
      }

      if (truck && truck.routes && truck.routes.length > 0) {
        return {
          estimatedDistance: this.helper.sumBy(truck.routes, 'distance') || 0,
          estimatedTravellingTime: this.helper.sumBy(truck.routes, 'time') || 0
        };
      }

      return {
        estimatedDistance: 0,
        estimatedTravellingTime: 0
      };
    }
  }, {
    key: "isTruckIdExistInGlobal",
    value: function isTruckIdExistInGlobal(truckId) {
      var _this3 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return Number(o['vehicleId']) === truckId && _this3.$userInformation && _this3.$userInformation.user && o.userId !== _this3.$userInformation.user.id;
      });
    }
  }]);
  return MilkRunV2Mixin;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin));

exports.MilkRunV2Mixin = MilkRunV2Mixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MilkRunV2Mixin.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MilkRunV2Mixin.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MilkRunV2Mixin.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], MilkRunV2Mixin.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfCustKey', {
  namespace: 'authentication'
})], MilkRunV2Mixin.prototype, "$lfCustKey", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfAPIToken', {
  namespace: 'authentication'
})], MilkRunV2Mixin.prototype, "$lfAPIToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('plan', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$plan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_MOBILE', {
  namespace: 'common'
})], MilkRunV2Mixin.prototype, "$setIsMobile", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE_RANGE', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setPlanDateRange", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_TRUCK', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setSelectedTruck", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_LOADING', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setTruckLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCKS', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_FILTERS', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setTruckFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_ORDERS', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setGlobalSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_TRUCKS', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setGlobalSelectedTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('initPlan', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$initPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setPlan', {
  namespace: 'milkRunV2'
})], MilkRunV2Mixin.prototype, "$setPlan", void 0);
exports.MilkRunV2Mixin = MilkRunV2Mixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], MilkRunV2Mixin);